export default "__VITE_ASSET__DYVJJ1Jj__"